import { render } from "./CoachwiseTrip.vue?vue&type=template&id=0d12bdb4&scoped=true"
import script from "./CoachwiseTrip.vue?vue&type=script&lang=js"
export * from "./CoachwiseTrip.vue?vue&type=script&lang=js"

import "./CoachwiseTrip.vue?vue&type=style&index=0&id=0d12bdb4&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d12bdb4"]])

export default __exports__